import { useQuery } from '@tanstack/react-query';
import { adminPartnerService } from '../services/admin-partner.service';

export interface AnalyticsFilterParams {
  startDate?: string;
  endDate?: string;
  serviceType?: string;
  partnerId?: string;
  groupBy?: 'DAY' | 'MONTH';
}

export function useAdminPartnerAnalytics(filters?: AnalyticsFilterParams) {
  const overviewQuery = useQuery({
    queryKey: ['admin', 'partners', 'analytics', 'overview', filters?.startDate, filters?.endDate, filters?.serviceType, filters?.partnerId],
    queryFn: () => adminPartnerService.getAnalyticsOverview({
      startDate: filters?.startDate,
      endDate: filters?.endDate,
      serviceType: filters?.serviceType,
      partnerId: filters?.partnerId,
    }),
  });

  const funnelQuery = useQuery({
    queryKey: ['admin', 'partners', 'analytics', 'funnel', filters?.startDate, filters?.endDate, filters?.partnerId],
    queryFn: () => adminPartnerService.getAnalyticsFunnel({
      startDate: filters?.startDate,
      endDate: filters?.endDate,
      partnerId: filters?.partnerId,
    }),
  });

  const financialTrendQuery = useQuery({
    queryKey: ['admin', 'partners', 'analytics', 'financial-trend', filters?.startDate, filters?.endDate, filters?.groupBy],
    queryFn: () => adminPartnerService.getFinancialTrend({
      startDate: filters?.startDate,
      endDate: filters?.endDate,
      groupBy: filters?.groupBy || 'DAY',
    }),
  });

  const cacComparisonQuery = useQuery({
    queryKey: ['admin', 'partners', 'analytics', 'cac-comparison', filters?.startDate, filters?.endDate],
    queryFn: () => adminPartnerService.getCacComparison({
      startDate: filters?.startDate,
      endDate: filters?.endDate,
    }),
  });

  return {
    overview: overviewQuery.data,
    isLoadingOverview: overviewQuery.isLoading,
    isErrorOverview: overviewQuery.isError,
    refetchOverview: overviewQuery.refetch,

    funnel: funnelQuery.data,
    isLoadingFunnel: funnelQuery.isLoading,
    isErrorFunnel: funnelQuery.isError,
    refetchFunnel: funnelQuery.refetch,

    financialTrend: financialTrendQuery.data,
    isLoadingFinancialTrend: financialTrendQuery.isLoading,
    isErrorFinancialTrend: financialTrendQuery.isError,
    refetchFinancialTrend: financialTrendQuery.refetch,

    cacComparison: cacComparisonQuery.data,
    isLoadingCacComparison: cacComparisonQuery.isLoading,
    isErrorCacComparison: cacComparisonQuery.isError,
    refetchCacComparison: cacComparisonQuery.refetch,

    isLoadingAny: overviewQuery.isLoading || funnelQuery.isLoading || financialTrendQuery.isLoading || cacComparisonQuery.isLoading,
  };
}
